// =====================================================================
// Captcha sağlayıcısı — TEK KAYNAK.
//
// NEDEN İKİ SAĞLAYICI: Google reCAPTCHA Rusya'da güvenilir değil (Holideus RU
// dağıtımı Yandex.Cloud üzerinde). Yandex SmartCaptcha ise yalnız Rusya için
// anlamlı. Aynı imaj iki pazarda da çalıştığı için seçim BUILD'e gömülemez;
// runtime-config.js'ten okunur.
//
// runtime-config.js boşsa (Cloudflare Pages, yerel geliştirme) sağlayıcı
// 'google' kalır → TourZone davranışı BİREBİR aynı.
// =====================================================================

const runtime = (typeof window !== 'undefined' && window.__TZ_CONFIG__) || {};

/** 'google' | 'yandex' */
export const CAPTCHA_PROVIDER =
    String(runtime.captchaProvider || process.env.REACT_APP_CAPTCHA_PROVIDER || 'google').toLowerCase() === 'yandex'
        ? 'yandex'
        : 'google';

// İstemci anahtarı GİZLİ DEĞİLDİR (sayfa kaynağında görünür); gizli olan sunucu
// anahtarıdır ve yalnız backend .env'inde durur.
// `recaptchaSiteKey` geriye dönük uyumluluk için korunuyor: mevcut dağıtımların
// runtime-config.js'i o adı kullanıyor ve deploy sırasında korunuyor.
export const CAPTCHA_SITE_KEY = String(
    runtime.captchaSiteKey || runtime.recaptchaSiteKey || process.env.REACT_APP_RECAPTCHA || ''
);

export const IS_YANDEX_CAPTCHA = CAPTCHA_PROVIDER === 'yandex';

// ---------------------------------------------------------------------
// Etkin widget'ı sıfırlama.
//
// Kod tabanının pek çok yerinde `window.grecaptcha.reset()` doğrudan çağrılıyor.
// SmartCaptcha'da böyle bir global YOK — o çağrılar ya patlar ya da sessizce
// hiçbir şey yapmaz ve token tek kullanımlık olduğu için ikinci deneme başarısız
// olur. Bu yüzden etkin widget kendi sıfırlama fonksiyonunu buraya kaydeder ve
// çağrı yerleri sağlayıcıyı bilmeden `resetCaptcha()` kullanır.
// ---------------------------------------------------------------------
let resetFn = null;

/** CaptchaBox mount olurken kendi reset'ini kaydeder. */
export const registerCaptchaReset = (fn) => {
    resetFn = typeof fn === 'function' ? fn : null;
};

/** Sağlayıcıdan bağımsız sıfırlama. Widget yoksa sessizce yutulur. */
export const resetCaptcha = () => {
    try {
        if (resetFn) {
            resetFn();

            return;
        }
        // Kayıt yoksa eski davranışa düş (ör. CaptchaBox henüz mount olmadıysa).
        if (typeof window !== 'undefined' && window.grecaptcha && window.grecaptcha.reset) {
            window.grecaptcha.reset();
        }
    } catch (e) {
        /* sıfırlama başarısızlığı akışı durdurmamalı */
    }
};
